import { useParams } from 'react-router-dom';

import { useEffect } from 'react';
import { Task } from '../../../../../domain/task/Task';
import { PlanDetailsActionType } from '../../context/actions';
import { usePlanDetailsContext } from '../../context/context';
import { useRetrieveActivePlanStops } from './useRetrieveActivePlanStops';

type UseRetrieveActivePlanTasksResponse = { data: Array<Task> };

// Hooks act as 'Adapter' layer.
export const useRetrieveActivePlanTasks = (): UseRetrieveActivePlanTasksResponse => {
  const { planDetailsState, planDetailsDispatch } = usePlanDetailsContext();
  const { data: stops } = useRetrieveActivePlanStops();
  const { planId } = useParams();

  useEffect(() => {
    if (stops) {
      const tasks = stops.reduce((acc, stop) => {
        const stopTasks = stop.tasks ? stop.tasks : [];
        if (stop.reports && stop.reports.length > 0) {
          stop.reports[0].tasks?.forEach((taskReport) => {
            const specificTask = stopTasks.find((task) => task.id === taskReport.task_id);
            if (specificTask) {
              specificTask.custom_fields?.update({ ...taskReport.custom_fields });
            }
          });
        }

        stopTasks.forEach((task) => {
          task.driver_id = stop.driver_id;
        });

        return [...acc, ...(stopTasks ?? [])];
      }, [] as Array<Task>);

      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_TASKS,
        payload: {
          tasks,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId, stops]);

  return {
    data: planDetailsState.tasks,
  };
};
